import { render } from "./successModel.vue?vue&type=template&id=84b82298"
import script from "./successModel.vue?vue&type=script&lang=js"
export * from "./successModel.vue?vue&type=script&lang=js"

import "./successModel.vue?vue&type=style&index=0&id=84b82298&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__